import React from 'react';
import { 
  BrainCircuit, BookOpen, Megaphone, Zap, Compass, Target, Activity,
  PieChart as PieChartIcon, Star, Download, Loader2, 
  Users, GraduationCap, Sparkles, Brain
} from 'lucide-react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';

import EditableAIBox from '../EditableAIBox';

// --- 1. BİREYSEL RAPOR ARAYÜZÜ ---
export const VakReportUI = ({ data, meta }) => {
  const topStyle = data.topStyle || "Görsel";
  const chartData = data.chartData || [];

  const VAK_DICT = {
    "Görsel": {
      icon: BookOpen, color: "text-blue-700", bg: "bg-blue-50", border: "border-blue-200", bar: "#3b82f6",
      desc: "Görerek ve izleyerek öğrenirler. Şekiller, renkler ve grafikler akıllarında daha kolay kalır.",
      study: "Çalışırken renkli fosforlu kalemler kullan, zihin haritaları çiz, eğitim videoları izle ve notlarını tablo/grafik haline getir."
    },
    "İşitsel": {
      icon: Megaphone, color: "text-purple-700", bg: "bg-purple-50", border: "border-purple-200", bar: "#a855f7",
      desc: "Duyarak ve dinleyerek öğrenirler. Sözel ifadeler, tartışmalar ve ses tonu öğrenmelerinde kritiktir.",
      study: "Notlarını sesli oku, dersleri (izin alarak) kaydet ve tekrar dinle, öğrendiğin konuları bir başkasına anlatarak tekrar et."
    },
    "Dokunsal": {
      icon: Zap, color: "text-orange-700", bg: "bg-orange-50", border: "border-orange-200", bar: "#f97316",
      desc: "Yaparak, dokunarak ve hareket ederek öğrenirler. Uzun süre sabit durmakta zorlanırlar.",
      study: "Çalışırken hareket et (yürüyerek ezber yap), ders aralarında sık ve kısa molalar ver, maket ve deney gibi materyallerle çalış."
    }
  };

  const activeDict = VAK_DICT[topStyle] || VAK_DICT["Görsel"];
  const ActiveIcon = activeDict.icon;

  return (
    <div className="space-y-6 print:space-y-4 font-sans flex flex-col print:min-h-[260mm]">
      {/* ÜST BAŞLIK */}
      <div className="bg-slate-900 text-white p-4 print:p-3 rounded-xl flex justify-between items-center shadow-sm print:bg-white print:text-black print:shadow-none print:border-b-2 print:border-slate-900">
        <div className="flex items-center gap-4 print:gap-3">
          <div className="h-12 w-12 print:h-9 print:w-9 rounded-xl flex items-center justify-center shadow-inner bg-blue-600 print:bg-slate-800">
            <BrainCircuit className="h-6 w-6 print:h-4 print:w-4 text-white"/>
          </div>
          <div>
            <h2 className="text-xl print:text-lg font-bold leading-none mb-1">
  VAK Öğrenme Tercihleri Profili
</h2>
            <span className="text-[10px] print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">
               {meta?.studentClass || "Sınıf Belirtilmemiş"} • ÖĞRENCİ NO: {meta?.studentNo || "-"}
            </span>
          </div>
        </div>
        <div className="bg-white/10 px-4 py-2 print:px-3 print:py-1.5 rounded-lg text-center print:border print:border-slate-300">
          <span className="text-2xl print:text-xl font-black block leading-none text-blue-300 print:text-blue-700">{data.scores?.[topStyle] || 0}</span>
          <span className="text-[9px] print:text-[9px] block opacity-70 uppercase font-bold mt-0.5">Tepe Puan</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-5 print:gap-4 shrink-0 avoid-break">
        
        {/* DONUT GRAFİK */}
        <div className="bg-white p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-col items-center justify-center h-[280px] print:h-[220px] print:border-slate-300">
          <h3 className="font-bold text-slate-800 text-xs uppercase tracking-widest mb-2 border-b pb-2 w-full text-center">Öğrenme Dağılımı</h3>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie data={chartData} cx="50%" cy="50%" innerRadius={55} outerRadius={80} paddingAngle={5} dataKey="A">
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={VAK_DICT[entry.subject]?.bar || '#cbd5e1'} />
                ))}
              </Pie>
             <Tooltip formatter={(value) => [`%${value}`, 'Oran']} />
            </PieChart>
          </ResponsiveContainer>
          <div className="flex gap-4 mt-2">
             {chartData.map((item, idx) => (
                <div key={idx} className="flex items-center text-[10px] font-bold text-slate-600">
                   <div className="w-3 h-3 rounded-full mr-1.5" style={{backgroundColor: VAK_DICT[item.subject]?.bar}}></div>
                   {item.subject}
                </div>
             ))}
          </div>
        </div>

        {/* BASKIN STİL KARTI */}
        <div className={`${activeDict.bg} p-6 print:p-5 rounded-2xl border ${activeDict.border} shadow-sm flex flex-col justify-center print:bg-white print:border-slate-300`}>
           <div className="flex items-center mb-3 border-b pb-2 opacity-80 print:border-slate-200">
              <ActiveIcon className={`h-6 w-6 print:h-5 print:w-5 mr-2 ${activeDict.color}`}/>
              <span className={`text-xs font-black uppercase tracking-widest ${activeDict.color}`}>
  Öne Çıkan Öğrenme Tercihi
</span>
           </div>
           <h3 className={`text-3xl print:text-2xl font-black leading-tight mb-3 ${activeDict.color}`}>
  {topStyle} Tercihi
</h3>
           <p className="text-sm print:text-xs text-slate-700 font-medium leading-relaxed">{activeDict.desc}</p>
        </div>

      </div>

      {/* STRATEJİ VE ÇALIŞMA TAVSİYELERİ */}
      <div className="bg-slate-50 p-6 print:p-5 rounded-2xl border border-slate-200 shadow-sm print:bg-white print:border-slate-300 flex-1 avoid-break">
         <h4 className="font-bold text-slate-800 text-sm print:text-xs uppercase tracking-widest border-b pb-3 mb-4 flex items-center">
            <Compass className="h-5 w-5 mr-2 text-indigo-600"/> Deneyebileceği Çalışma Stratejileri
         </h4>
         <p className="text-sm print:text-[11px] text-slate-800 font-medium leading-relaxed text-justify bg-white print:bg-slate-50 p-4 print:p-3 rounded-xl border border-slate-100 print:border-slate-200">
           {activeDict.study}
         </p>
         
         <div className="mt-5">
           <h5 className="text-[11px] font-bold text-slate-500 uppercase tracking-wider mb-2">Tüm Dağılım Skorları (Max: 20 Puan)</h5>
           <div className="space-y-3">
              {chartData.map((item, idx) => (
                <div key={idx}>
                   <div className="flex justify-between text-[10px] font-bold text-slate-600 mb-1">
                      <span>{item.subject}</span>
                      {/* YENİ MOTOR: rawCount = Ham Puan (örn: 8), A = Yüzde (örn: 40) */}
                      <span>{item.rawCount} Puan (%{item.A})</span>
                   </div>
                   <div className="h-1.5 w-full bg-slate-200 rounded-full overflow-hidden">
                      {/* Genişliği artık 'A' (Yüzde) belirliyor */}
                      <div className="h-full rounded-full" style={{ width: `${item.A}%`, backgroundColor: VAK_DICT[item.subject]?.bar }}></div>
                   </div>
                </div>
              ))}
           </div>
         </div>
      </div>
    </div>
  );
};


// --- 2. KURUMSAL (TOPLU) HESAPLAMA MOTORU ---
export const aggregateVAK = (subs) => {
  const total = subs.length;
  if (total === 0) return null;

  const styleCounts = { 'Görsel': 0, 'İşitsel': 0, 'Dokunsal': 0 };
  const totalScores = { 'Görsel': 0, 'İşitsel': 0, 'Dokunsal': 0 };
  const classMap = {};

  subs.forEach(s => {
    const className = s.studentClass || s.sinif || "Tüm Sınıflar";
    if (!classMap[className]) {
      classMap[className] = { name: className, studentCount: 0, styles: { 'Görsel': 0, 'İşitsel': 0, 'Dokunsal': 0 } };
    }
    classMap[className].studentCount++;

    const topStyle = s.reportData?.topStyle;
    if (topStyle && styleCounts[topStyle] !== undefined) {
       styleCounts[topStyle]++;
       classMap[className].styles[topStyle]++;
    }

    const scores = s.reportData?.scores;
    if (scores) {
       totalScores['Görsel'] += scores['Görsel'] || 0;
       totalScores['İşitsel'] += scores['İşitsel'] || 0;
       totalScores['Dokunsal'] += scores['Dokunsal'] || 0;
    }
  });

  const avgScores = Object.keys(totalScores).map(key => ({
    name: key,
    avg: total > 0 ? (totalScores[key] / total).toFixed(1) : 0,
    percent: total > 0 ? Math.round((totalScores[key] / (total * 20)) * 100) : 0
  })).sort((a, b) => b.avg - a.avg);

  const dominantStylesList = Object.entries(styleCounts).map(([name, count]) => ({
    name, count, percent: total > 0 ? Math.round((count / total) * 100) : 0
  })).sort((a, b) => b.count - a.count);

  const classStats = Object.values(classMap).map(c => {
     const top = Object.keys(c.styles).reduce((a,b) => c.styles[a] > c.styles[b] ? a : b);
     return {
       ...c,
       topStyle: top,
       percentInClass: c.studentCount > 0 ? Math.round((c.styles[top] / c.studentCount) * 100) : 0
     };
  }).sort((a, b) => b.studentCount - a.studentCount);

  return { total, styleCounts, avgScores, dominantStylesList, classStats };
};


// --- 3. KURUMSAL RAPOR ARAYÜZÜ ---
export const VakKurumsalUI = ({ title, subs, aiResult, onGenerateAI, aiLoading, handlePrint, downloading }) => {
  const data = aggregateVAK(subs);
  if (!data) return <div className="p-8 text-center text-slate-500">Bu gruba ait veri bulunamadı.</div>;

  const topStyle = data.dominantStylesList[0] || { name: "Görsel", percent: 0 };
  
  const VAK_DICT = {
    "Görsel": { icon: BookOpen, color: "text-blue-700", bg: "bg-blue-50", bar: "bg-blue-500" },
    "İşitsel": { icon: Megaphone, color: "text-purple-700", bg: "bg-purple-50", bar: "bg-purple-500" },
    "Dokunsal": { icon: Zap, color: "text-orange-700", bg: "bg-orange-50", bar: "bg-orange-500" }
  };
  
  const TopIcon = VAK_DICT[topStyle.name]?.icon || Star;
  const topColor = VAK_DICT[topStyle.name]?.color || "text-slate-800";

  return (
    <>
      <div className="flex justify-end mb-4 no-print px-2">
         <button onClick={() => handlePrint('vak-kurumsal-area')} disabled={downloading} className="bg-blue-600 text-white px-5 py-2.5 rounded-xl font-bold flex items-center text-sm shadow-md hover:bg-blue-700 transition">
            {downloading ? <Loader2 className="animate-spin h-5 w-5 mr-2"/> : <Download className="h-5 w-5 mr-2"/>} Raporu Yazdır / PDF
         </button>
      </div>

      <div id="vak-kurumsal-area" className="font-sans flex flex-col bg-white print:bg-white">
        <div className="flex flex-col gap-5 print:gap-3 mb-6 print:mb-0">
          
          <div className="bg-slate-900 text-white p-5 print:p-3 rounded-2xl flex justify-between items-center shadow-sm shrink-0 avoid-break print:bg-white print:text-black print:border-b-2 print:border-slate-900">
            <div className="flex items-center gap-5 print:gap-3">
              <div className="h-14 w-14 print:h-10 print:w-10 rounded-xl flex items-center justify-center shadow-inner bg-blue-600 print:bg-slate-800">
                <BrainCircuit className="h-7 w-7 print:h-5 print:w-5 text-white"/>
              </div>
              <div>
                <h2 className="text-2xl print:text-lg font-black leading-none mb-1">{title}</h2>
                <span className="text-xs print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">ÖĞRENME STİLLERİ (VAK) PROFİLİ</span>
              </div>
            </div>
            <div className="bg-white/10 px-5 py-2.5 rounded-xl text-center print:border print:border-slate-300">
              <span className="text-3xl print:text-xl font-black block text-blue-300 print:text-blue-700">{data.total}</span>
              <span className="text-[10px] print:text-[8px] block opacity-70 uppercase font-bold mt-1">Katılımcı</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-5 print:gap-3 shrink-0 avoid-break">
            <div className={`p-5 print:p-4 rounded-2xl border shadow-sm flex flex-col justify-center ${VAK_DICT[topStyle.name]?.bg} print:bg-white print:border-slate-300`}>
              <div className="flex items-center mb-1.5">
                 <TopIcon className={`h-6 w-6 print:h-4 print:w-4 mr-2 ${topColor}`}/>
                 <span className={`text-sm print:text-[10px] font-black uppercase tracking-widest ${topColor}`}>Kurumsal Baskın Stil</span>
              </div>
              <p className={`text-2xl print:text-lg font-black mt-1 ${topColor}`}>{topStyle.name} <span className="text-xs font-medium opacity-70">(%{topStyle.percent})</span></p>
            </div>
            
            <div className="bg-slate-50 p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-col print:bg-white print:border-slate-300">
               <h3 className="font-bold text-slate-800 flex items-center text-xs uppercase tracking-widest border-b border-slate-200 pb-2 mb-3">
                  <PieChartIcon className="h-4 w-4 mr-2 text-slate-600"/> Stil Dağılım Oranları
               </h3>
               <div className="space-y-2">
                  {data.dominantStylesList.map((st, idx) => (
                    <div key={idx}>
                      <div className="flex justify-between items-end mb-0.5">
                        <span className="text-[10px] font-bold text-slate-700">{st.name}</span>
                        <span className="text-[10px] font-black text-slate-900">%{st.percent}</span>
                      </div>
                      <div className="h-1.5 w-full bg-slate-200 rounded-full overflow-hidden">
                        <div className="h-full rounded-full" style={{ width: `${st.percent}%`, backgroundColor: VAK_DICT[st.name]?.bar }}></div>
                      </div>
                    </div>
                  ))}
               </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-5 print:gap-3 shrink-0 avoid-break mt-1 print:mt-0">
            <div className="col-span-1 bg-indigo-50 p-5 print:p-3.5 rounded-2xl border border-indigo-100 flex flex-col justify-center shadow-sm print:bg-white print:border-slate-300">
               <h3 className="font-bold text-indigo-900 mb-3 flex items-center text-xs uppercase tracking-widest border-b border-indigo-200 pb-1.5"><Users className="h-5 w-5 mr-2 text-indigo-600"/> Sınıfların Öğrenme Karakteri</h3>
               <div className="space-y-2 mt-1">
                 <div>
                    <span className="text-[10px] font-bold text-indigo-500 uppercase tracking-widest block mb-0.5">Grup: {data.classStats[0] ? data.classStats[0].name : '-'}</span>
                    <p className="text-sm font-black text-slate-800 leading-tight">Baskın: {data.classStats[0] ? data.classStats[0].topStyle : 'Belirsiz'} <span className="text-[10px] font-bold text-indigo-600">(%{data.classStats[0]?.percentInClass})</span></p>
                 </div>
                 {data.classStats[1] && (
                 <div>
                    <span className="text-[10px] font-bold text-slate-500 uppercase tracking-widest block mb-0.5">Grup: {data.classStats[1].name}</span>
                    <p className="text-xs font-black text-slate-700 leading-tight">Baskın: {data.classStats[1].topStyle} <span className="text-[10px] font-bold text-indigo-500">(%{data.classStats[1].percentInClass})</span></p>
                 </div>
                 )}
               </div>
            </div>

            <div className="col-span-1 bg-amber-50 p-5 print:p-3.5 rounded-2xl border border-amber-100 flex flex-col justify-center shadow-sm print:bg-white print:border-slate-300">
               <h3 className="font-bold text-amber-900 mb-3 flex items-center text-xs uppercase tracking-widest border-b border-amber-200 pb-1.5"><GraduationCap className="h-5 w-5 mr-2 text-amber-600"/> Pedagojik Eylem Planı</h3>
               <p className="text-[11px] text-slate-700 leading-snug font-medium mt-1 text-justify">
                 Öğrencilerin <strong>%{(data.dominantStylesList[0]?.percent || 0)}</strong>'si <strong>{topStyle.name}</strong> ağırlıklı öğrenmektedir. Derslerde düz anlatımdan ziyade, {topStyle.name === 'Görsel' ? 'şekillere, haritalara ve videolara' : topStyle.name === 'İşitsel' ? 'sesli okumalara ve grup tartışmalarına' : 'yaparak yaşayarak öğrenmeye ve materyallere'} ağırlık veren bir müfredat işlenmelidir.
               </p>
            </div>
          </div>
        </div>

{/* YENİ EKLENEN: DİKEY VİZYONER STRATEJİ KARTLARI (Sınıf İçi Rehber) */}
          {(() => {
              // 1. Kart: Fiziksel Ortam Tasarımı İçerikleri
              const environmentStrategies = {
                  "Görsel": [
                      "Sınıf içi oturma düzeninde 'U düzeni' tercih edilerek tahta ve materyal görüş alanı maksimize edilmelidir.",
                      "Sınıf panoları; kavram haritaları, infografikler ve renkli şemalarla donatılarak öğrenme duvarı oluşturulmalıdır.",
                      "Derslerde akıllı tahta aktif kullanılmalı, önemli kavramlar farklı renkli kalemlerle vurgulanmalıdır."
                  ],
                  "İşitsel": [
                      "Öğrencilerin tartışma gruplarına kolay dahil olabileceği küme oturma düzenleri oluşturulmalıdır.",
                      "Sınıf içi yankıyı azaltacak düzenlemeler yapılmalı, anlatım esnasında dış seslerden izole bir ortam sağlanmalıdır.",
                      "Bilgi aktarımı sırasında fon müziği, podcast veya sesli materyallerin kullanılabileceği istasyonlar kurulmalıdır."
                  ],
                  "Dokunsal": [
                      "Sınıf içinde öğrencilerin hareket edebileceği, ayağa kalkıp etkinlik yapabileceği geniş alanlar bırakılmalıdır.",
                      "Materyal köşeleri kurularak; maketler, yapbozlar, deney setleri veya dokunulabilir objeler sergilenmelidir.",
                      "Öğrencilerin pasif oturmasını engelleyecek, laboratuvar veya atölye formatına yakın bir sınıf dizaynı tercih edilmelidir."
                  ]
              };

              // 2. Kart: Ölçme ve Değerlendirme İçerikleri
              const evaluationStrategies = {
                  "Görsel": [
                      "Sınavlarda uzun metinler yerine görsellere, haritalara ve eşleştirme sorularına ağırlık verilmelidir.",
                      "Öğrencilerden proje olarak poster tasarımı, slayt sunumu veya bir konunun resmedilmesi istenebilir.",
                      "Değerlendirme rubrikleri, öğrencinin bilgiyi ne kadar iyi görselleştirdiğine odaklanacak şekilde tasarlanmalıdır."
                  ],
                  "İşitsel": [
                      "Sözlü sınavlar, panel tartışmaları ve grup sunumları öncelikli değerlendirme kriteri olarak kullanılmalıdır.",
                      "Yazılı sınavlarda öğrencilerin zihinlerinde tartışabilecekleri açık uçlu, senaryo bazlı sorular sorulmalıdır.",
                      "Öğrencilerden bir konuyu anlatırken kendi seslerini kaydetmeleri veya podcast hazırlamaları proje olarak verilebilir."
                  ],
                  "Dokunsal": [
                      "Performans ödevleri, model tasarımı ve laboratuvar deneyleri üzerinden uygulamalı olarak değerlendirilmelidir.",
                      "Çoktan seçmeli sorular yerine, 'Bir problemi çözmek için hangi adımları uygularsın?' tarzı süreç odaklı sorular sorulmalıdır.",
                      "Sınıf içi drama etkinlikleri, rol yapma ve fiziksel manipülasyon içeren ürün dosyaları (portfolyo) notlandırılmalıdır."
                  ]
              };

              const envList = environmentStrategies[topStyle.name] || environmentStrategies["Görsel"];
              const evalList = evaluationStrategies[topStyle.name] || evaluationStrategies["Görsel"];

              // 3. Kart: Pasta Grafik Verileri (Donut Chart)
              const pieData = data.dominantStylesList.map(item => ({
                  name: item.name,
                  value: item.percent,
                  color: VAK_DICT[item.name]?.bar || '#64748b'
              }));

              // 4. Kart: İhtiyaç Endeksi Verileri
              const getVal = (name) => data.dominantStylesList.find(s => s.name === name)?.percent || 0;
              const indices = [
                  { label: "Görsel Materyal İhtiyacı", val: getVal("Görsel"), color: "bg-blue-500", text: "text-blue-700", icon: BookOpen },
                  { label: "Etkileşimli İletişim Eğilimi", val: getVal("İşitsel"), color: "bg-purple-500", text: "text-purple-700", icon: Megaphone },
                  { label: "Fiziksel Hareket ve Uygulama", val: getVal("Dokunsal"), color: "bg-orange-500", text: "text-orange-700", icon: Zap }
              ];

              return (
                  <>
                      {/* ÜST SATIR (1. ve 2. Kartlar - Metin Odaklı) */}
                      <div className="grid grid-cols-2 gap-5 print:gap-3 mt-4 print:mt-2 avoid-break">
                          {/* Kart 1: Fiziksel Ortam */}
                          <div className="bg-slate-50/80 rounded-2xl p-4 print:p-3 border border-slate-200 shadow-sm flex flex-col print:bg-white print:border-slate-300">
                              <h4 className="font-bold text-slate-800 text-[11px] uppercase tracking-widest border-b border-slate-200 pb-2 mb-3 flex items-center">
                                  <Compass className="h-4 w-4 mr-2 text-indigo-600" /> Sınıf İçi Fiziksel Ortam ve Materyal Tasarımı
                              </h4>
                              <ul className="space-y-2.5 print:space-y-2 mt-1">
                                  {envList.map((item, index) => (
                                      <li key={index} className="flex items-start text-[11px] print:text-[10px] text-slate-700 font-medium leading-relaxed">
                                          <div className="h-1.5 w-1.5 rounded-full bg-indigo-500 mt-1.5 mr-2 shrink-0"></div>
                                          <span>{item}</span>
                                      </li>
                                  ))}
                              </ul>
                          </div>

                          {/* Kart 2: Ölçme ve Değerlendirme */}
                          <div className="bg-slate-50/80 rounded-2xl p-4 print:p-3 border border-slate-200 shadow-sm flex flex-col print:bg-white print:border-slate-300">
                              <h4 className="font-bold text-slate-800 text-[11px] uppercase tracking-widest border-b border-slate-200 pb-2 mb-3 flex items-center">
                                  <Target className="h-4 w-4 mr-2 text-emerald-600" /> Stratejik Ölçme ve Değerlendirme Yöntemleri
                              </h4>
                              <ul className="space-y-2.5 print:space-y-2 mt-1">
                                  {evalList.map((item, index) => (
                                      <li key={index} className="flex items-start text-[11px] print:text-[10px] text-slate-700 font-medium leading-relaxed">
                                          <div className="h-1.5 w-1.5 rounded-full bg-emerald-500 mt-1.5 mr-2 shrink-0"></div>
                                          <span>{item}</span>
                                      </li>
                                  ))}
                              </ul>
                          </div>
                      </div>

                      {/* ALT SATIR (3. ve 4. Kartlar - Görsel/Grafik Odaklı) */}
                      <div className="grid grid-cols-2 gap-5 print:gap-3 mt-4 print:mt-3 avoid-break">
                          
                          {/* Kart 3: Stil Dağılım Grafiği (Donut Chart) */}
                          <div className="bg-slate-50/80 rounded-2xl p-4 print:p-3 border border-slate-200 shadow-sm flex flex-col print:bg-white print:border-slate-300">
                              <h4 className="font-bold text-slate-800 text-[11px] uppercase tracking-widest border-b border-slate-200 pb-2 mb-2 flex items-center">
                                  <PieChartIcon className="h-4 w-4 mr-2 text-rose-600" /> Sınıf Geneli Stil Grafiği
                              </h4>
                              <div className="h-32 w-full flex-1">
                                  <ResponsiveContainer width="100%" height="100%">
                                      <PieChart>
                                          <Pie
                                              data={pieData}
                                              cx="50%" cy="50%"
                                              innerRadius={35}
                                              outerRadius={55}
                                              paddingAngle={5}
                                              dataKey="value"
                                          >
                                              {pieData.map((entry, index) => (
                                                  <Cell key={`cell-${index}`} fill={entry.color} />
                                              ))}
                                          </Pie>
                                          <Tooltip formatter={(value) => [`%${value}`, 'Oran']} />
                                      </PieChart>
                                  </ResponsiveContainer>
                              </div>
                              <div className="flex justify-center gap-4 mt-2 print:mt-1">
                                  {pieData.map((entry, idx) => (
                                      <div key={idx} className="flex items-center text-[10px] font-bold text-slate-600">
                                          <span className="w-2.5 h-2.5 rounded-full mr-1.5" style={{ backgroundColor: entry.color }}></span>
                                          {entry.name}
                                      </div>
                                  ))}
                              </div>
                          </div>

                          {/* Kart 4: Ekosistem İhtiyaç Endeksi (Barlar) */}
                          <div className="bg-slate-50/80 rounded-2xl p-4 print:p-3 border border-slate-200 shadow-sm flex flex-col print:bg-white print:border-slate-300">
                              <h4 className="font-bold text-slate-800 text-[11px] uppercase tracking-widest border-b border-slate-200 pb-2 mb-3 flex items-center">
                                  <Activity className="h-4 w-4 mr-2 text-teal-600" /> Sınıf Ekosistemi İhtiyaç Endeksi
                              </h4>
                              <div className="space-y-4 flex-1 flex flex-col justify-center">
                                  {indices.map((item, idx) => (
                                      <div key={idx}>
                                          <div className="flex justify-between items-end mb-1.5">
                                              <span className={`text-[10px] font-bold flex items-center ${item.text}`}>
                                                  <item.icon className="h-3 w-3 mr-1.5" /> {item.label}
                                              </span>
                                              <span className="text-[11px] font-black text-slate-800">% {item.val}</span>
                                          </div>
                                          <div className="h-2 w-full bg-slate-200 rounded-full overflow-hidden print:border print:border-slate-300">
                                              <div className={`h-full rounded-full ${item.color} print:bg-slate-500`} style={{ width: `${item.val}%` }}></div>
                                          </div>
                                      </div>
                                  ))}
                              </div>
                          </div>

                      </div>
                  </>
              );
          })()}

        <div className="hidden print:block" style={{ pageBreakBefore: 'always' }}></div>

        {/* AI RAPORU BÖLÜMÜ */}
        <div className="flex flex-col mt-4 print:mt-0">
          <div className="bg-purple-50 p-6 print:p-0 rounded-3xl border border-purple-100 shadow-sm flex flex-col pt-2 print:bg-white print:border-none print:shadow-none">
            <div className="flex justify-between items-center mb-4 border-b border-purple-200 pb-3 shrink-0 print:border-slate-300">
              <h3 className="font-bold text-purple-900 flex items-center text-base uppercase tracking-widest print:hidden"><Sparkles className="h-5 w-5 mr-2 text-purple-600"/> Yapay Zeka Strateji Raporu</h3>
              <h3 className="hidden print:flex items-center font-bold text-slate-900 text-sm uppercase tracking-widest w-full"><Brain className="h-5 w-5 mr-2"/> Kurumsal Öğrenme Stilleri (VAK) Gelişim Planı</h3>
              <button onClick={() => onGenerateAI(title, data.dominantStylesList)} disabled={aiLoading} className="px-5 py-2.5 bg-purple-600 text-white rounded-xl font-bold text-xs hover:bg-purple-700 transition shadow-sm print:hidden flex items-center">
                {aiLoading ? <Loader2 className="animate-spin h-4 w-4 mr-2"/> : <Brain className="h-4 w-4 mr-2"/>} {aiLoading ? "Analiz Ediliyor..." : "Raporu Oluştur"}
              </button>
            </div>
            {aiResult && (
            <div className="bg-white p-6 rounded-xl text-slate-800 border border-purple-100 print:border-0 print:p-0 print:text-black mt-4">
                <EditableAIBox text={aiResult} />
            </div>
        )}
          </div>
        </div>
      </div>
    </>
  );
};